export default __webpack_public_path__ + "static/media/inventory-icon-empty-gray.e14fe14f.svg";